import { FunctionComponent, useCallback, useState } from 'react'
import { MdCheck, MdPlayArrow } from 'react-icons/md'

import Button from 'shared/components/Button'
import Modal from 'shared/components/Modal'
import { validateTypeFile } from 'shared/utils/validates'

import { steps } from '../../'
import iconPhone from 'shared/assets/icons/icon-telefone.png'
import cnh from 'shared/assets/images/cnh.jpeg'
import rg from 'shared/assets/images/rg.png'
import InputFile from 'shared/components/InputFile'
import { colors } from 'shared/styles/colors'
import { IPhotoProps } from './PhotoComponent.types'
import {
  Container,
  Cnh,
  ContainerCenter,
  ContainerDoc,
  ContainerInput,
  ContainerModal,
  ContainerPhoto,
  Description,
  Rg,
  Title,
  StyledPage,
} from './styles'

const Photo: FunctionComponent<IPhotoProps> = ({ setSelectedStep }) => {
  const [photoOk, setPhotoOk] = useState(() => {
    if (localStorage.getItem('@TMov:ChangeGestorPhotoBase64')) {
      return true
    }

    return false
  })
  const [file, setFile] = useState(() => {
    if (localStorage.getItem('@TMov:ChangeGestorPhotoName')) {
      return localStorage.getItem('@TMov:ChangeGestorPhotoName')
    }

    return ''
  })
  const [openModal, setOpenModal] = useState(true)
  const [isWrongExtension, setIsWrongExtension] = useState(false)

  const handleSelectFile = useCallback((base64: string, fileName: string) => {
    setFile(fileName)
    if (validateTypeFile(fileName)) {
      setIsWrongExtension(false)
      localStorage.setItem('@TMov:ChangeGestorPhotoBase64', base64)
      localStorage.setItem('@TMov:ChangeGestorPhotoName', fileName)
      setPhotoOk(true)
    } else {
      setIsWrongExtension(true)
      setPhotoOk(false)
    }
  }, [])

  return (
    <>
      <Modal
        size={'large'}
        showCloseButton={true}
        openModal={openModal}
        onCloseModal={() => {
          setOpenModal(false)
        }}
      >
        <ContainerModal>
          <Title>Atenção!</Title>

          <Description>
            Seu documento precisa estar aberto para validarmos frente e verso,
            como no exemplo a seguir:
          </Description>

          <ContainerDoc>
            <ContainerPhoto>
              <Rg src={rg} />
              <Title>RG</Title>
            </ContainerPhoto>
            <ContainerPhoto>
              <Cnh src={cnh} />
              <Title>CNH</Title>
            </ContainerPhoto>
          </ContainerDoc>

          <Button
            color={colors.orange}
            onClick={() => {
              setOpenModal(false)
            }}
          >
            <MdCheck /> Ok
          </Button>
        </ContainerModal>
      </Modal>
      <StyledPage
        icon={iconPhone}
        title="Boa!<br />Estamos quase lá, agora precisamos de uma imagem do seu RG ou CNH (frente e verso):"
        goBackTo={() => {
          setSelectedStep(steps.Phone)
        }}
      >
        <Container>
          <ContainerInput>
            <InputFile
              id="photo-singup"
              onSelectFile={handleSelectFile}
              file={file}
              isWrongExtension={isWrongExtension}
            />
          </ContainerInput>
          <ContainerCenter>
            <Button
              color={photoOk ? colors.green : colors.grayLight}
              disabled={!photoOk}
              onClick={() => {
                setSelectedStep(steps.NewPassword)
              }}
            >
              <MdPlayArrow /> Próximo
            </Button>
          </ContainerCenter>
        </Container>
      </StyledPage>
    </>
  )
}

export default Photo
